import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="section about" id="about">
      <div className="section-center">
        <div className="section-title about-title">
          <h2
            className="animate"
            data-animate="tracking-in-expand 1s cubic-bezier(0.215, 0.610, 0.355, 1.000) both"
          >
            About me
          </h2>
          <div className="underline"></div>
        </div>

        <div className="about-center animate" data-animate="slideInLeft 2s">
          <div className="about-center-info">
            <h3>Get to know me!</h3>
            <p>
              My name is Tran Huu Thang, nickname Mr.Katsu, I like to do new things and want to know more experience in my programming industry.
              <br />I enjoy coding and the challenge of learning something new
              everyday
            </p>
          </div>

          <div className="animate" data-animate="slideInRight 2s">
            <h3>Education</h3>
            <div>
              <p>2018-2022</p>
              <h4>The University of Danang, University of Education</h4>
            </div>
            <div>
              <p>Major</p>
              <h4>Information Technology</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
